<script lang="ts">
  import { LOCALES, LANG_NAMES, getLocale, setLocale, t, type Locale } from '../i18n/index.svelte';
  import Icon from './Icon.svelte';
  import viFlag from '../assets/flags/vietnamese.png';
  import enFlag from '../assets/flags/english.png';
  import ruFlag from '../assets/flags/russian.png';
  import zhFlag from '../assets/flags/chinese.png';
  import thFlag from '../assets/flags/thai.png';

  // Cờ ứng với từng ngôn ngữ (nguồn: design/BAZIS Plugin UI/flags).
  const FLAGS: Record<Locale, string> = {
    vi: viFlag,
    en: enFlag,
    ru: ruFlag,
    zh: zhFlag,
    th: thFlag,
  };

  let open = $state(false);
  let root: HTMLDivElement;

  function choose(l: Locale) {
    setLocale(l);
    open = false;
  }
  function onWinClick(e: MouseEvent) {
    if (open && root && !root.contains(e.target as Node)) open = false;
  }
</script>

<svelte:window
  onclick={onWinClick}
  onkeydown={(e) => e.key === 'Escape' && (open = false)}
/>

<div class="lang" bind:this={root}>
  <button
    class="trigger"
    type="button"
    aria-haspopup="listbox"
    aria-expanded={open}
    aria-label={t('lang.label')}
    title={t('lang.label')}
    onclick={() => (open = !open)}
  >
    <img class="flag" src={FLAGS[getLocale()]} alt="" />
    <span class="name">{LANG_NAMES[getLocale()]}</span>
    <Icon name={open ? 'chevronUp' : 'chevronDown'} size={14} />
  </button>

  {#if open}
    <ul class="menu" role="listbox" aria-label={t('lang.label')}>
      {#each LOCALES as l (l)}
        <li>
          <button
            class="opt"
            class:active={l === getLocale()}
            type="button"
            role="option"
            aria-selected={l === getLocale()}
            onclick={() => choose(l)}
          >
            <img class="flag" src={FLAGS[l]} alt="" />
            <span>{LANG_NAMES[l]}</span>
            {#if l === getLocale()}<Icon name="check" size={14} />{/if}
          </button>
        </li>
      {/each}
    </ul>
  {/if}
</div>

<style>
  .lang {
    position: relative;
  }
  .trigger {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 32px;
    padding: 0 8px;
    border: 1px solid var(--color-border);
    border-radius: var(--radius-pill);
    background: var(--color-surface-glass);
    color: var(--color-text-primary);
    font: inherit;
    font-size: var(--font-size-caption);
    font-weight: 600;
    cursor: pointer;
    backdrop-filter: blur(10px);
  }
  .trigger:hover {
    border-color: var(--color-primary);
  }
  .flag {
    width: 20px;
    height: 14px;
    object-fit: cover;
    border-radius: 2px;
    border: 1px solid var(--color-border);
    flex: none;
    display: block;
  }
  .menu {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    z-index: var(--z-modal);
    min-width: 160px;
    margin: 0;
    padding: 4px;
    list-style: none;
    background: var(--color-surface);
    border: 1px solid var(--color-border);
    border-radius: var(--radius-control);
    box-shadow: var(--shadow-panel);
  }
  .opt {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 8px;
    border: none;
    border-radius: var(--radius-control);
    background: transparent;
    color: var(--color-text-primary);
    font: inherit;
    font-size: var(--font-size-caption);
    font-weight: 600;
    text-align: left;
    cursor: pointer;
  }
  .opt span {
    flex: 1;
    min-width: 0;
  }
  .opt:hover {
    background: var(--color-canvas-bottom);
    color: var(--color-primary);
  }
  .opt.active {
    color: var(--color-primary);
  }

  /* mobile: thu gọn trigger còn cờ + mũi tên (tên ngôn ngữ đè logo trên màn hẹp).
     Menu xổ ra vẫn hiển thị đầy đủ tên + cờ. */
  @media (max-width: 767px) {
    .trigger .name {
      display: none;
    }
  }
</style>
